import { useEffect, useMemo, useState } from 'react';

import { ProgressContext } from '../ProgressContext/ProgressContext';
import { ProgressContextProps } from '../ProgressContext/ProgressContext.types';
import { useValidationStepData } from '@percent/hosted-validation-form/app/HostedForm/HostedForm/validationStepContext/useValidationStepData/useValidationStepData';
import { HostedFormStep } from '@percent/hosted-validation-form/app/HostedForm/HostedForm/HostedForm.types';
import { usePartnerConfig } from '@percent/hosted-validation-form/hooks/usePartnerConfig/usePartnerConfig';

export const ProgressContextController = ({ children }: ProgressContextProps) => {
  const { validationStep } = useValidationStepData();
  const { partnerConfig } = usePartnerConfig();
  const otpEnabled = !!partnerConfig?.configuration?.otpEnabled;

  // OTP is only part of the flow for partners that have it enabled — leaving it in
  // the denominator otherwise would make every other step report less progress.
  const steps = useMemo(
    () => Object.keys(HostedFormStep).filter((step) => otpEnabled || step !== HostedFormStep.OTP),
    [otpEnabled],
  );
  const maxProgress = steps.length - 1;

  const [progress, setProgress] = useState((1 / maxProgress) * 100);

  useEffect(() => {
    if (validationStep) {
      const currentStepIndex = steps.indexOf(validationStep);

      return setProgress((currentStepIndex / maxProgress) * 100);
    }
  }, [validationStep, steps, maxProgress]);

  return <ProgressContext.Provider value={{ progress, setProgress }}>{children}</ProgressContext.Provider>;
};
